import React, { FC } from "react";

import style from "./styles/badge.scss";

export interface TabBadgeProps {
    background?: "blue" | "green" | "orange" | "red";
    text: string;
}

export const TabBadge: FC<TabBadgeProps> = (props: TabBadgeProps) => {
    const wrapperClass = props.background || "blue";

    return <span className={style[wrapperClass]}>{props.text}</span>;
};
